export enum EStoreFlag {
	DBIsSyncing = "dbIsSyncing",
	DBIsCompiling = "dbIsCompiling",
	DBInitializing = "dbInitializing",
	DBInitialized = "dbInitialized",
	DBDeleting = "dbDeleting",
	DBStartupInitialized = "dbStartupInitialized",
	DBLocalInitialized = "dbLocalInitialized"
}